module.exports = __webpack_public_path__ + "static/media/retail-pos.ce02c7f8.jpg";